var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreatePostIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 32,
    viewBox: "0 0 24 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2126_283)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.62 3H7.31C5.45 3 4.43 3 3.71 3.7C3 4.4 3 5.42 3 7.26V21L6.38 19.89L9.19 20.82L12 19.89L15.38 21V9.67H19.64C20.02 9.67 20.27 9.67 20.52 9.51C20.65 9.43 20.76 9.32 20.84 9.19C21 8.94 21 8.69 21 8.32V6.34C21 4.5 19.49 3.01 17.62 3.01V3ZM14.25 6.33V19.45L12 18.71L9.19 19.64L6.38 18.71L4.13 19.45V7.26C4.13 5.56 4.14 4.86 4.51 4.49C4.88 4.13 5.59 4.11 7.31 4.11H15.11C14.57 4.7 14.25 5.48 14.25 6.33ZM19.63 8.56H15.37V6.34C15.37 5.11 16.38 4.12 17.62 4.12C18.86 4.12 19.87 5.12 19.87 6.34V8.32C19.87 8.41 19.87 8.5 19.87 8.56C19.8 8.56 19.71 8.56 19.63 8.56Z",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75 9.11C6.75 9.42 7 9.67 7.31 9.67H11.06C11.37 9.67 11.62 9.42 11.62 9.11C11.62 8.8 11.37 8.55 11.06 8.55H7.31C7 8.55 6.75 8.8 6.75 9.11Z",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.06 13.27H7.31C7 13.27 6.75 13.52 6.75 13.83C6.75 14.14 7 14.39 7.31 14.39H11.06C11.37 14.39 11.62 14.14 11.62 13.83C11.62 13.52 11.37 13.27 11.06 13.27Z",
    fill: "#616161"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3047 19.4238V20.4434H17.457V19.4238H23.3047ZM20.9258 16.9336V23.1445H19.8418V16.9336H20.9258Z",
    fill: "#616161"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2126_283"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreatePostIcon);
export default __webpack_public_path__ + "static/media/createPostIcon.84fd2ec74465d2d466cc76cfcbc37843.svg";
export { ForwardRef as ReactComponent };